<div *ngIf="showSpinner" class="loader">
  <ng-container [ngSwitch]="loader.type">
    <app-spinner-loader *ngSwitchCase="'spinner'"></app-spinner-loader>

    <app-infinity-loader *ngSwitchCase="'infinity'"></app-infinity-loader>

    <app-time-loader *ngSwitchCase="'time'"></app-time-loader>

    <app-bounce-dots-loader *ngSwitchCase="'bounce-dots'"></app-bounce-dots-loader>

    <app-rotating-square-loader *ngSwitchCase="'rotating-square'"></app-rotating-square-loader>

    <app-growing-bars-loader *ngSwitchCase="'growing-bars'"></app-growing-bars-loader>

    <app-bounce-bars-loader *ngSwitchCase="'bounce-bars'"></app-bounce-bars-loader>

    <app-music-bars-loader *ngSwitchCase="'music-bars'"></app-music-bars-loader>
  </ng-container>
</div>
